import React, { useContext, useCallback, useState, useEffect } from 'react';
import { CarrierDriverFilter, TasksHandledByFilter } from '../../../components/ShipmentFilters';
import DocsContext from 'containers/Docs/context/DocsContext';
import Select from 'react-select-v3';
import { reactSelectStyles } from 'utils/style';

const countryOptions = [
  { label: 'Spain', value: 'ES' },
  { label: 'France', value: 'FR' },
  { label: 'UK', value: 'UK' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'Any', value: '' },
];

const DocsFilters = ({ className }) => {
  const t = {
    docType: 'Document Type',
    country: 'Country',
  };

  const { fetchDocumentTypes, documentTypes, filters, setFilters } = useContext(DocsContext);
  const [docTypeOptions, setDocTypeOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(
    countryOptions.find((country) => country.value === filters.country)
  );
  const [selectedDocumentTypes, setSelectedDocumentTypes] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState('all');

  const filterCarrier = useCallback(
    (filteredCarrier) => {
      setFilters({ ...filters, carrier_id: filteredCarrier?.value?.id || '' });
    },
    [filters, setFilters]
  );

  const filterDocType = useCallback(
    async (selectedOption) => {
      const docTypeFilters = selectedOption ? selectedOption : [];
      setFilters({ ...filters, document_type: docTypeFilters.map((a) => a.value) });
      setSelectedDocumentTypes(docTypeFilters);
    },
    [setSelectedDocumentTypes, filters, setFilters]
  );

  const filterCountry = useCallback(
    (selectedOption) => {
      setSelectedCountry(
        countryOptions.find((country) => country.value === selectedOption.value) || null
      );
      setFilters({ ...filters, country: selectedOption.value });
    },
    [setSelectedCountry, filters, setFilters]
  );

  const filterOwner = useCallback(
    (owner) => {
      setSelectedOwner(owner);
      setFilters({ ...filters, owner: owner !== 'all' ? owner.email || 'no_owner' : '' });
    },
    [filters, setFilters, setSelectedOwner]
  );

  const generateOptions = useCallback(() => {
    if (!documentTypes) return [];
    setDocTypeOptions(
      documentTypes.map((docType) => {
        return {
          value: docType.id,
          label: docType.label,
        };
      })
    );
  }, [documentTypes]);

  useEffect(() => {
    if (documentTypes && docTypeOptions.length === 0) {
      generateOptions();
    }
  }, [documentTypes, docTypeOptions, generateOptions]);

  useEffect(() => {
    if (!documentTypes) {
      fetchDocumentTypes();
    }
  }, [fetchDocumentTypes, documentTypes]);

  return (
    <div className={className}>
      <div className="docs-filters" data-testid="docs-filters">
        <div className="docs-filters__row">
          <CarrierDriverFilter
            onChange={filterCarrier}
            stylingProps={{ width: 'auto', marginRight: 0, last: true }}
            containerWidth="auto"
            selectStyles={{ containerWidth: 'auto' }}
          />
        </div>
        <div className="docs-filters__row" data-testid="doc-type-filter">
          <Select
            isMulti
            closeMenuOnSelect
            className="docs-filters__select"
            containerWidth="auto"
            placeholder={t.docType}
            name="document_type"
            options={docTypeOptions}
            onChange={filterDocType}
            value={selectedDocumentTypes}
            styles={{
              ...reactSelectStyles,
              indicatorSeparator: () => {
                /*noop*/
              },
            }}
          />
        </div>
        <div className="docs-filters__row" data-testid="country-filter">
          <Select
            className="docs-filter__select"
            containerWidth="auto"
            placeholder={t.country}
            value={selectedCountry}
            name="country"
            options={countryOptions}
            onChange={filterCountry}
            styles={reactSelectStyles}
          />
        </div>
        <div className="docs-filters__row" data-testid="owner-filter">
          <TasksHandledByFilter
            filterUserGroups="FLEET, ProdTech"
            value={selectedOwner}
            onChange={filterOwner}
          />
        </div>
      </div>
    </div>
  );
};

export default DocsFilters;
